export class BackupPolicyPlan {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "backupPolicyType",
            "baseName": "backupPolicyType",
            "type": "BackupPolicyType",
            "format": ""
        },
        {
            "name": "standardPlan",
            "baseName": "standardPlan",
            "type": "StandardBackupPolicyPlan",
            "format": ""
        },
        {
            "name": "highFrequencyPlan",
            "baseName": "highFrequencyPlan",
            "type": "HighFrequencyBackupPolicyPlan",
            "format": ""
        },
        {
            "name": "awsNativeHighFrequencyPlan",
            "baseName": "awsNativeHighFrequencyPlan",
            "type": "AwsNativeHighFrequencyBackupPolicyPlan",
            "format": ""
        },
        {
            "name": "pitrPlan",
            "baseName": "pitrPlan",
            "type": "PitrBackupPolicyPlan",
            "format": ""
        },
        {
            "name": "awsNativePitrPlan",
            "baseName": "awsNativePitrPlan",
            "type": "AwsNativePitrBackupPolicyPlan",
            "format": ""
        },
        {
            "name": "bigQueryNativePitrPlan",
            "baseName": "bigQueryNativePitrPlan",
            "type": "BigQueryNativePitrBackupPolicyPlan",
            "format": ""
        },
        {
            "name": "awsNativeStandardPlan",
            "baseName": "awsNativeStandardPlan",
            "type": "AwsNativeStandardBackupPolicyPlan",
            "format": ""
        },
        {
            "name": "azureFilesPlan",
            "baseName": "azureFilesPlan",
            "type": "AzureFilesBackupPolicyPlan",
            "format": ""
        },
        {
            "name": "azureSqlDatabaseNativePitrPlan",
            "baseName": "azureSqlDatabaseNativePitrPlan",
            "type": "AzureSqlDatabaseNativePitrBackupPolicyPlan",
            "format": ""
        },
        {
            "name": "googleWorkspacePlan",
            "baseName": "googleWorkspacePlan",
            "type": "GoogleWorkspaceBackupPolicyPlan",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BackupPolicyPlan.attributeTypeMap;
    }
    constructor() {
    }
}
